import React, { useState, useEffect } from "react";
import { View, StyleSheet } from "react-native";

import EmptyStar from "./icons/EmptyStar";
import FilledStar from "./icons/FilledStar";

export default function StarRating({
  rating = 3,
  numberOfStars = 5,
  starSize = 38,
  style = {},
  onPress = () => {},
}) {
  const [selectedRating, setSelectedRating] = useState(null);

  useEffect(() => {
    setSelectedRating(rating);
  }, []);

  const changeRating = (newRating) => {
    setSelectedRating(newRating);
    onPress(newRating);
  };

  return (
    <View style={[styles.container, style]}>
      {[...Array(numberOfStars)].map((e, index) => {
        return index < selectedRating ? (
          <FilledStar
            key={index}
            width={starSize}
            height={starSize}
            onPress={() => changeRating(index + 1)}
          />
        ) : (
          <EmptyStar
            width={starSize}
            height={starSize}
            key={index}
            onPress={() => changeRating(index + 1)}
          />
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
});
